import gql from "graphql-tag";

const getAti = (bookingNumber) => (gql`
{
    ati (bookingNumber: "${bookingNumber}") {
        ReservationId
        Nationalities {
            Code
            Name
        }
        Persons {
            ReservationPersonId
            DisplayName
            Values {
                FieldId
                Key
                Value
                Type
                ValidationMessageLocalized
                KeyLocalized
            }
        }
    }
}
`)

export {
    getAti
}
